package com.devi3east.bashbuddy.prizeList.navigation

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.NavType
import androidx.navigation.compose.composable
import androidx.navigation.navArgument
import androidx.navigation.navDeepLink
import androidx.savedstate.read
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.data.api.BASE_URL
import com.devi3east.bashbuddy.features.events.detail.navigation.EVENT_ID_ARG
import com.devi3east.bashbuddy.features.events.detail.navigation.EVENT_SLUG_ARG
import com.devi3east.bashbuddy.prizeList.ui.PrizeListRoute

fun NavController.navigateToPrizeList(
    eventId: String,
    slug: String,
    navOptions: NavOptions? = null
) {
    navigate(
        Screen.PrizeListScreen.createRoute(eventId, slug),
        navOptions
    )
}

fun NavGraphBuilder.prizeListNavGraph(
    appState: AppState
) {
    composable(
        route = Screen.PrizeListScreen.route,
        arguments = listOf(
            navArgument(EVENT_ID_ARG) {
                type = NavType.StringType
                nullable = false
            },
            navArgument(EVENT_SLUG_ARG) {
                type = NavType.StringType
                nullable = false
            }
        ),
        deepLinks = listOf(
            navDeepLink {
                uriPattern =
                    "{$BASE_URL}/event/{$EVENT_ID_ARG}/{$EVENT_SLUG_ARG}/prizelist"

            }
        )
    ) { backStackEntry ->

        val args = backStackEntry.arguments ?: return@composable

        val eventId = args.read {
            getString(EVENT_ID_ARG)
        }

        PrizeListRoute(
            appState = appState,
            eventId = eventId
        )
    }
}